import React from 'react'
import './Style/SaC.css'
import './Style/OceanSaC.css'

import closedChest from './Graphics/closedchest2.png'
import openChest from './Graphics/openchest2.png'

import sign from './Graphics/floatingsign.png'

import leftShort from './Graphics/bubblesdiagonaleft.png'
import rightShort from './Graphics/bubblesdiagonaright.png'
import leftTall from './Graphics/bubblesdiagonalefttall.png'
import rightTall from './Graphics/bubblesdiagonarighttall.png'
import leftTaller from './Graphics/bubblesdiagonalefttaller.png'
import rightTaller from './Graphics/bubblesdiagonarighttaller.png'

//Bubble trails for the chests that float in the ocean. Each side is picked
//independently so no two chests read as a matching pair, and the taller trails
//sit lower to make room for the extra bubbles. Width is a % of the chest, so
//everything scales with it.
const bubblePresets = [
  {
    left:  { src: leftShort,   width: '30%', bottom: '5%' },
    right: { src: rightTaller, width: '24%', bottom: '5%' },
  },
  {
    left:  { src: leftShort,  width: '24%', bottom: '78%' },
    right: { src: rightTaller,width: '30%', bottom: '56%' },
  },
  {
    left:  { src: leftTaller, width: '28%', bottom: '58%' },
    right: { src: rightShort,  width: '26%', bottom: '30%' },
  },
  {
    left:  { src: leftTall,   width: '26%', bottom: '70%' },
    right: { src: rightTall,  width: '30%', bottom: '60%' },
  },
]

//The ocean chests only ever render under 768px, so the sign text is left to the
//mobile rules in SaC.css rather than taking the fSize/topPercent props SaC uses.
const OceanSignandChest = ({title, rotation=0, setVis, visIndex, curVis, preset=0}) => {
  const bubbles = bubblePresets[preset % bubblePresets.length];

  return (
     <div className='SandC oceanSandC' style={{rotate:`${rotation}deg`}} onClick={() =>setVis(visIndex)}>
                <img className="sign" src={sign} alt=""/>
                <img className="bubbles bubblesLeft" src={bubbles.left.src} alt=""
                     style={{width:bubbles.left.width, bottom:bubbles.left.bottom}}/>
                <img className="bubbles bubblesRight" src={bubbles.right.src} alt=""
                     style={{width:bubbles.right.width, bottom:bubbles.right.bottom}}/>
                {(visIndex===curVis) ? <img className="chest" src={openChest} alt={title}/> :<img className="chest" src={closedChest} alt={title}/>}
                <p className="signTxt">{title}</p>
      </div>
  )
}

export default OceanSignandChest
